import {
  ACTION_SET_LAST_UPDATE_TIME,
} from '../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_SET_LAST_UPDATE_TIME:
      return action.payload.lastUpdateTime;

    default:
      return state;
  }
};
